import { AfterViewInit, Component, ElementRef, HostListener, Inject, OnDestroy, PLATFORM_ID, ViewChild } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { isPlatformBrowser, Location } from '@angular/common';

import { languages } from '../../shared/constants/app-enums';
import { EventService } from '../../services/event.service';
import { WalletConnectService } from '../../services/wallet-connect.service';
import { ConnectComponent } from '../../modals/connect/connect.component';
import { language } from '../../shared/interfaces/wallet.interface';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements AfterViewInit, OnDestroy {
  @ViewChild('navigation') navigation!: ElementRef;
  subscription!: Subscription;
  isScrolled: boolean = false;
  showMenu: boolean = false;
  openMenu: boolean = false;
  modalRef?: BsModalRef;
  hashKey: string = '';
  server: string = environment.server;
  currentLanguage = '';
  languagesList = languages;
  selectedLanguage: language = {} as language;
  isMobile: boolean = false;
  windowSize: number = 0;
  pageIndex: number = 0;

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    this.isScrolled = window.pageYOffset >= 50;
  }

  navigations = [
    {
      routeName: 'home',
      navName: 'top_navigation.nav_home',
    },
     {
      routeName: 'about',
      navName: 'top_navigation.nav_about',
    },
    {
      routeName: 'how-to-buy',
      navName: 'top_navigation.nav_howtobuy',
    },
    {
      routeName: 'roadmap',
      navName: 'top_navigation.nav_roadmap',
    },
    {
      routeName: 'tokenomics',
      navName: 'top_navigation.nav_tokenomics',
    },
    {
      routeName: 'faq',
      navName: 'top_navigation.nav_faq',
    },
  ];

  social = [
    {
      img: 'assets/images/social-icons/twitter.svg',
      alt: 'twitter',
      link: 'https://x.com/Pepenode_io',
    },
    {
      img: 'assets/images/social-icons/telegram.svg',
      alt: 'telegram',
      link: 'https://t.me/pepe_node',
    },
  ];

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (isPlatformBrowser(this._platformId)) {
      this.windowSize = window.innerWidth;
      this.isMobile = this.windowSize <= 1024 ? true : false;
    }
  }

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private location: Location,
    private eventService: EventService,
    private translate: TranslateService,
    private modalService: BsModalService,
    private walletConnectService: WalletConnectService,
  ) {
    this.subscription = this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      // console.log('LangChangeEvent called in header', params.lang);
      this.currentLanguage = params.lang;
      this.selectedLanguage = this.languagesList.filter((x) => x.value === this.currentLanguage)[0];
      if (isPlatformBrowser(this._platformId)) localStorage.setItem('lang', this.currentLanguage);
    });

   this.eventService.getEvent('SLIDETO').subscribe((param: any) => {
     const sections =  this.eventService.sliderArr;      
     if(param <= sections.length && param >=0){
      const mode = sections[param];
      this.addActive(this.navigation.nativeElement, mode === 'home' ? '': mode );
     }
    });
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this._platformId)) {
      this.windowSize = window.innerWidth;
      this.isMobile = this.windowSize <= 1024 ? true : false;
      if (!this.currentLanguage) {
        this.currentLanguage = localStorage.getItem('lang') || 'en';
        this.selectedLanguage = this.languagesList.filter((x) => x.value === this.currentLanguage)[0];
      }

      const pathName = window.location.pathname.split('/')[2] || window.location.pathname.split('/')[1] || '';
      this.hashKey =  window.location.hash ? window.location.hash.substring(1, window.location.hash.length) : '';
      // console.log('/npathName =', pathName, '/nhashKey =',this.hashKey)
      setTimeout(() => this.addActive(this.navigation.nativeElement, pathName, true), 1000);
    }
  }

  changeLanguage(requestLang: string): void {
    if (this.currentLanguage !== requestLang) {
      this.currentLanguage = requestLang;
      this.translate.use(this.currentLanguage);
      this.eventService.setLang(this.currentLanguage);
      this.selectedLanguage = this.languagesList.filter((x) => x.value === this.currentLanguage)[0];
      this.replaceURL();
    }
  }

  replaceURL(): void {
    const current_url = this.location.path().split('/');
    current_url.shift();
    const isStaking = current_url.includes("staking")
    current_url.splice(0, 1, (this.currentLanguage === 'en' && !isStaking) ? '' : this.currentLanguage);
    const new_url = this.hashKey ? current_url.join('/') + `#${this.hashKey}` : current_url.join('/');
    this.location.go('/' + new_url);
  }

  addActive(event: Event, section: string, autoMode: boolean = false) {
    if(!autoMode) this.hashKey = section && section != 'staking' ? section : '';
    const target: any = event.currentTarget ? event.currentTarget : event;
    let linkList = target.parentNode.querySelectorAll('a');
    linkList.forEach((link: any) => {
      if (link === event.target || link.title === section) {
        link.classList.add('active');
      } else if ((this.hashKey === '' || null) && link.title === 'home' && section !=='staking'){
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
    const index = this.eventService.getSliderIndex(section);
    if(index != this.pageIndex){
      this.pageIndex = index;
      if (this.pageIndex>=0 && section) this.eventService.broadcastEvent('SLIDETO', this.eventService.getSliderIndex(section))
    }
  }

  get walletAddress(): string {
    return this.walletConnectService.walletAddress;
  }

  showWidget(section: string): void {
    if (window.location.pathname.includes('dashboard')) {
      window.scroll({ top: 0 });
      this.connectModal();
    } else {
      this.eventService.showBuyWidget(section);
    }
  }

  connectModal(): void {
    this.modalRef = this.modalService.show(ConnectComponent, {
      class: 'modal-xs modal-dialog-centered',
      backdrop: 'static',
    });
  }

  disconnect(): void {
    this.walletConnectService.disConnectWallet();
  }

  openCloseMenu(): void {
    if (this.showMenu) {
      this.openMenu = !this.openMenu;
      setTimeout(() => (this.showMenu = !this.showMenu), 600);
    } else {
      this.showMenu = !this.showMenu;
      setTimeout(() => (this.openMenu = !this.openMenu), 300);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
